import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get, post, put } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalFormState({
  stateSelect,
  callback,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    name: '',
    state: true,
    isPiece: false,
    isFluid: false,
    isComponent: false,
  });

  const handleClose = () => setShow(false);
  const handleShow = async (state) => {
    if (state) {
      const infostate = await get('/config/states/' + state);
      if (infostate.success) {
        const infoState = infostate.data;
        setForm({ ...infoState });
      }
    }
    setShow(true);
  };

  const handleForm = ({ target }) => {
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setForm({ ...infoForm, [target.name]: value });
  };

  const saveForm = async (e) => {
    let respo,
      variant = '',
      msg = '';

    const body = { ...infoForm };
    if (stateSelect) {
      respo = await put('/config/states/modify/' + stateSelect, body);
      msg = 'Estado editado Correctamente';
    } else {
      respo = await post('/config/states/create', body);
      msg = 'Estado Creado Correctamente';
    }

    if (respo.success) {
      variant = 'success';
    } else {
      variant = 'danger';
      msg = respo.message;
    }
    setForm({
      name: '',
      state: true,
      isPiece: false,
      isFluid: false,
      isComponent: false,
    });
    handleClose();
    callback(variant, msg);
  };

  useEffect(() => {
    const initForm = () => {};

    initForm();
  }, []);

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(stateSelect)}
      />

      <Modal animation={false}  fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form.Label htmlFor="nombre">Nombre</Form.Label>
            <Form.Control
              name="name"
              value={infoForm.name}
              onChange={(e) => handleForm(e)}
              type="text"
            />
            <Form.Check
              className="mb-4"
              type="switch"
              name="state"
              label="Activo"
              checked={infoForm.state}
              onChange={(e) => handleForm(e)}
            />
          </Container>
          <Container className="m-3">
            <Row className="mt-3">Estados aplicables A</Row>
            <Row className="mt-3">
              <Col className="mt-1">
                <Form.Check
                  type="switch"
                  id="isPiece"
                  name="isPiece"
                  label="Piezas"
                  checked={infoForm.isPiece}
                  onChange={(e) => handleForm(e)} 
                />
              </Col>
              <Col className="mt-1">
                <Form.Check
                  type="switch"
                  id="isFluid"
                  name="isFluid"
                  label="Fluidos"
                  checked={infoForm.isFluid}
                  onChange={(e) => handleForm(e)} 
                />
              </Col>
              <Col className="mt-1">
                <Form.Check
                  type="switch"
                  id="isComponent"
                  name="isComponent"
                  label="Componentes"
                  checked={infoForm.isComponent}
                  onChange={(e) => handleForm(e)} 
                />
              </Col>
            </Row>
          </Container>
          <Container>
            <Row className="text-center m-3">
              <Col>
                <Button variant="secondary">Limpiar Formulario</Button>
              </Col>
              <Col>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={(e) => saveForm(e)}
                >
                  Guardar Informacion
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormState;
